import React from "react";

export default function CloseButton({handleClose}:{handleClose:()=>void}) {
  return (
    <div
      className={`close_icon clickable`}
      onClick={(e) => {
        e.stopPropagation()
        handleClose()
      }}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3047 12.5938C13.0703 12.8281 12.6406 12.8281 12.4062 12.5938L7.25 7.39844L2.05469 12.5938C1.82031 12.8281 1.39062 12.8281 1.15625 12.5938C0.921875 12.3594 0.921875 11.9297 1.15625 11.6953L6.35156 6.5L1.15625 1.34375C0.921875 1.10938 0.921875 0.679688 1.15625 0.445312C1.39062 0.210938 1.82031 0.210938 2.05469 0.445312L7.25 5.64062L12.4062 0.445312C12.6406 0.210938 13.0703 0.210938 13.3047 0.445312C13.5391 0.679688 13.5391 1.10938 13.3047 1.34375L8.10938 6.5L13.3047 11.6953C13.5391 11.9297 13.5391 12.3594 13.3047 12.5938Z"
          fill="black"
        />
      </svg>
    </div>
  );
}
